// @ts-nocheck

export const VOID_REASONS = Object.freeze({
  // __('Goalscorer Guarantee')
  230: 'Goalscorer Guarantee',
  // __('Starting 5 Guarantee')
  231: 'Starting 5 Guarantee',
});
